import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SchedulerService } from '../../scheduler.service';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { ServerResponseCode } from '../response.code.constants';
import { ScheduleRequest, ScheduleUpdateRequest, SchedulerResultData } from '../../scheduler.model';
import { regExps, OapStandarErrorStateMatcher, errorMessages, OapErrorMessages } from 'src/app/modules/custom-validators/custom-validators.module';
import { formatDate, DatePipe } from '@angular/common';

export interface SampleCronExpression {
  value: string;
  viewValue: string;
}

export interface JobType {
  value: string;
  description: string;
}


@Component({
  selector: 'oap-detail-scheduler',
  templateUrl: './detail-scheduler.component.html',
  styleUrls: ['./detail-scheduler.component.scss']
})
export class DetailSchedulerComponent implements OnInit {
  schedulerForm: FormGroup;
  jobNameStatus: String;
  jobNameStatusClass: string;

  isEditMode = false;
  showCheckJobName = false;

  title: string;
  informations = '';

  jobNameRequested: string;

  matcher = new OapStandarErrorStateMatcher();
  errors = errorMessages;
  validation_messages = OapErrorMessages;

  minDate: Date = new Date(formatDate(Date.now(), 'MM/dd/yyyy', 'en'));
  maxDate: Date = new Date(9999, 12, 31);

  sampleCronExpressions: SampleCronExpression[] = [
    {value: '0 0/1 * * * ? *', viewValue: 'A 0 seconde, toutes les 1 minutes'},
    {value: '0 0 10 * * ? *', viewValue: 'Tous les jours à 10:00:00'},
    {value: '30 30 18 * * ? *', viewValue: 'Tous les jours à 18:30:30'},
    {value: '0 0 15/1 * * ? *', viewValue: 'Toutes les heures à partir de 15:00:00 jusqu\'à 23:00:00'},
    {value: '0 0 10 ? * TUE,THU *', viewValue: 'A 10:00:00 tous les mardi et jeudi'}
  ];

  jobTypes: JobType[] = [];

  constructor(private _router: Router,
    private _route: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _schedulerService: SchedulerService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.jobNameStatus = '';

    this.informations = '';

    this.jobNameRequested = this._route.snapshot.paramMap.get('jobName');
    console.log('jobNameRequested: ' + this.jobNameRequested);

    this.schedulerForm = this._formBuilder.group({
      jobName: ['', [Validators.required,
        Validators.maxLength(120),
        Validators.pattern(regExps.characterJobNameAuthorized)]],
      scheduleTime: ['', [Validators.required]],
      jobType: [''],
      hour: ['', [Validators.min(0),
        Validators.max(23),
        Validators.pattern(regExps.onlyDigits)]],
      minute: ['', [Validators.min(0),
        Validators.max(59),
        Validators.pattern(regExps.onlyDigits)]],
      second: ['', [Validators.min(0),
        Validators.max(59),
        Validators.pattern(regExps.onlyDigits)]],
      cronExpression: ['', [Validators.required]]
    });


    this._schedulerService.getJobTypes().subscribe(
      response => {
        console.log('getJobTypes http response status : ' + response.status);
        const data = response.body.data;

        let i = 1;
        data.forEach((element: { name: any; description: any; }) => {
          const entity: JobType = {value: element.name, description: element.description};
          this.jobTypes.push(entity);
          i++;
        });
      },
      error => {
        console.error(error);
      },
      () => { console.log('default'); }
    );

    if (this.jobNameRequested) {
      this.title = 'Modifier une tâche';
      this.isEditMode = true;

      this._schedulerService.jobDetail(this.jobNameRequested)
      .subscribe(
          response => {
            console.log('http response status : ' + response.status);
            const serverResponse = response.body;

            const entity: SchedulerResultData = new SchedulerResultData();
            entity.rowId = 1;
            entity.jobName = serverResponse.data.jobName,
            entity.groupName = serverResponse.data.groupName,
            entity.jobType = serverResponse.data.jobType,
            entity.scheduleTime =  serverResponse.data.scheduleTime,
            entity.lastFiredTime =  serverResponse.data.lastFiredTime,
            entity.nextFireTime =  serverResponse.data.nextFireTime,
            entity.jobStatus =  serverResponse.data.jobStatus,
            entity.cronExpression = serverResponse.data.cronExpression;

            this.setForm(entity);

          },
          error => {
            console.error(error);
          });

    } else {
      this.title = 'Ajouter une tâche';

      const date = new Date();
      this.schedulerForm.patchValue({
        scheduleTime: date,
      });
    }

    this.setDate();

  }

  setDate(): void {
    const date = new Date();
    this.schedulerForm.patchValue({
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      hour: date.getHours(),
      minute: date.getMinutes(),
      second: 0
    });
  }

  resetForm() {
    var dateNow = new Date();
    this.schedulerForm.patchValue({
      jobName: '',
      year: dateNow.getFullYear(),
      month: dateNow.getMonth() + 1,
      day: dateNow.getDate(),
      hour: dateNow.getHours(),
      minute: dateNow.getMinutes()
    });
    this.jobNameStatus = '';
  }

  getFormattedDate(date: string, hour, minute, second) {
    return date + ' ' + hour + ':' + minute + ':' + second;
  }

  onFormSubmit(form: FormGroup) {

    // stop here if form is invalid
    if (this.schedulerForm.invalid) {
      return;
    }

    const hour = padLeft(this.schedulerForm.value.hour, 2);
    const minute = padLeft(this.schedulerForm.value.minute, 2);
    const second = padLeft(this.schedulerForm.value.second, 2);

    const datePipe = new DatePipe('en');
    const scheduleTime: string = datePipe.transform(this.schedulerForm.controls.scheduleTime.value, 'yyyy-MM-dd');

    if (this.isEditMode) {
      const scheduleUpdateRequest: ScheduleUpdateRequest = {
        'jobName': this.schedulerForm.value.jobName,
        'cronExpression': this.schedulerForm.value.cronExpression,
        'jobScheduleTime': this.getFormattedDate(scheduleTime, hour, minute, second)
      };
      this.updateJob(scheduleUpdateRequest);
    } else {
      const scheduleRequest: ScheduleRequest = {
        'jobClass': this.schedulerForm.value.jobType.value,
        'jobName': this.schedulerForm.value.jobName,
        'cronExpression': this.schedulerForm.value.cronExpression,
        'jobScheduleTime': this.getFormattedDate(scheduleTime, hour, minute, second)
      };
      this.createJob(scheduleRequest);
    }
  }

  createJob(scheduleRequest: ScheduleRequest) {
    this._schedulerService.scheduleJob(scheduleRequest).subscribe(
      response => {
        console.log('http response status : ' + response.status);
        const serverResponse = response.body;

        if (serverResponse.statusCode === ServerResponseCode.SUCCESS) {
          this._router.navigateByUrl('/admin/scheduler');
        } else if (serverResponse.statusCode === ServerResponseCode.JOB_WITH_SAME_NAME_EXIST) {
          alert('Job with same name exists, Please choose different name.');

        } else if (serverResponse.statusCode === ServerResponseCode.JOB_NAME_NOT_PRESENT) {
          alert('Job name is mandatory.');
        }
      },
      err => {
        console.log(err);
        this.displayTextFor(err, 3000);
      });
  }

  updateJob(scheduleUpdateRequest: ScheduleUpdateRequest) {

    this._schedulerService.updateJob(scheduleUpdateRequest).subscribe(
      response => {
        const serverResponse = response.body;

        if (serverResponse.statusCode === ServerResponseCode.SUCCESS) {
          this._router.navigateByUrl('/admin/scheduler');
        } else if (serverResponse.statusCode === ServerResponseCode.JOB_DOESNT_EXIST) {
          alert('Job no longer exist.');

        } else if (serverResponse.statusCode === ServerResponseCode.JOB_NAME_NOT_PRESENT) {
          alert('Please provide job name.');
        }
      },
      err => {
        alert('Error while updating job');
      });
  }

  editJob(selectedJobRow) {
    this.isEditMode = true;

    const date = new Date(selectedJobRow.scheduleTime);
    this.schedulerForm.patchValue({
      jobName: selectedJobRow.jobName,
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      hour: date.getHours(),
      minute: date.getMinutes()
    });
  }

  private setForm(entity: SchedulerResultData) {
    const date = new Date(entity.scheduleTime);
    this.schedulerForm.patchValue({
      jobName: entity.jobName,
      jobType: entity.jobType,
      scheduleTime: date,
      hour: date.getHours(),
      minute: date.getMinutes(),
      second: date.getSeconds(),
      cronExpression: entity.cronExpression
    });

    console.log('entity.jobType :' + entity.jobType);
    const toSelect = this.jobTypes.find(j => j.value === entity.jobType);
    this.schedulerForm.get('jobType').setValue(toSelect);
  }

  checkJobExistWith(jobName: string) {
    this._schedulerService.isJobWithNamePresent(jobName).subscribe(
      response => {
        console.log('http response status : ' + response.status);
        const serverResponse = response.body;
        if (serverResponse.statusCode === ServerResponseCode.SUCCESS) {
          if (serverResponse.data === true) {
            this.jobNameStatus = ' KO \'' + jobName + '\' est déjà utilisé.';
            this.jobNameStatusClass = 'job-name-ko';
          } else {
            this.jobNameStatus = ' OK \'' + jobName + '\' peut être utilisé.';
            this.jobNameStatusClass = 'job-name-ok';
          }
        } else if (serverResponse.statusCode === ServerResponseCode.JOB_NAME_NOT_PRESENT) {
          this.schedulerForm.patchValue({
            jobName: '',
          });
        }
      },
      error => {
        console.error(error);
      },
      () => { console.log('default'); }
    );
    this.jobNameStatus = '';
  }

  cronChange(cronExp) {
    this.schedulerForm.patchValue({
      cronExpression: cronExp
    });
  }

  private displayTextFor(text: string, displayTime: number) {
    this.informations = text;
    setTimeout(() => { this.informations = ''; }, displayTime);
  }


  onKeyUpJobName() {
    if(this.schedulerForm.value.jobName && this.schedulerForm.value.jobName.length > 0 ) {
      this.showCheckJobName = true;
    } else {
      this.showCheckJobName = false;
    }
  }

}

function padLeft (num: number, size: number): string {
  let s = num + '';
  while (s.length < size) { s = '0' + s; }
  return s;
}
